<template>
  <div
    id="ChatBox"
    :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
    v-loading="messagesLoading"
  >
    <div
      class="panel panel-default"
      :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
    >
      <div class="panel-body">
        <div class="uk-grid-small uk-flex-middle" uk-grid>
          <div class="uk-width-auto">
            <span
              uk-icon="icon:  chevron-left; ratio: 2.5"
              v-if="$store.state.chat.isMobileMode"
              @click="fnreturnListChat"
              :style="{ color: 'white', cursor: 'pointer' }"
            ></span>
            <a v-show="activeChatCustomer.custImage">
              <img
                width="64"
                height="64"
                v-bind:src="
                  `https://cdnx.softsq.com/thumb/unsafe/84x84/${encodeURIComponent(
                    encodeURIComponent(activeChatCustomer.custImage),
                  )}`
                "
                class="uk-border-circle"
                data-src="holder.js/64x64"
                style="width: 54px; height: 54px;"
                data-holder-rendered="true"
              />
            </a>
          </div>
          <div class="uk-width-expand">
            <h4
              class="uk-margin-remove-bottom uk-margin-remove-top"
              :style="{ color: 'white' }"
            >
              {{ activeChatCustomerName }}
              <el-tag
                v-if="!activeChatCustomer.hold"
                style="margin-left: 8px;"
                effect="plain"
                size="medium"
                type="info"
                class="pointer"
                @click="$store.dispatch('chat/holdActiveChatCustomer')"
                >Hold</el-tag
              >
              <el-tag
                v-if="activeChatCustomer.hold"
                style="margin-left: 8px;"
                effect="dark"
                size="medium"
                type="warning"
                class="pointer"
                @click="$store.dispatch('chat/unHoldActiveChatCustomer')"
                >Hold</el-tag
              >
              <span
                v-if="aiSuggestGlobalEnabled"
                class="ai-toggle-wrapper"
                style="margin-left: 12px; display: inline-flex; align-items: center; gap: 6px;"
              >
                <span style="color: #fff; font-size: 12px;">AI</span>
                <el-switch
                  v-model="aiSuggestToggle"
                  :loading="aiSuggestLoading"
                  active-color="#13ce66"
                  inactive-color="#909399"
                  @change="handleAiSuggestToggle"
                ></el-switch>
                <span
                  class="ai-select-btn"
                  :class="{ active: selectedMessageIds.length > 0 }"
                  title="Select messages for AI suggestion"
                  style="visibility: hidden;"
                >
                  <i class="fas fa-hand-pointer"></i>
                </span>
              </span>
              &nbsp;
              <span>ชื่อเดิม: {{ activeChatCustomer.custName }}</span>
              <span
                style="font-size: 1.1em; cursor:pointer;"
                @click="copyName(activeChatCustomer.custName)"
                ><u>Copy to clipboard</u></span
              >
            </h4>

            <span
              class="icon-edit"
              @click="
                $store.dispatch(
                  'contact/setActiveContactCustumer',
                  activeChatCustomer,
                )
              "
            >
              <i class="far fa-edit"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="ChatBox_writeSpace"
      v-if="!$store.state.chat.isMobileMode"
    ></div>
    <div class="ChatBox__Content">
      <transition name="component-fade" mode="out-in">
        <div
          v-if="messageScroll.length > 0"
          @click="setScrollDown"
          class="tag-newMessage"
        >
          <el-tag type="success">
            {{ 'ข้อความมาใหม่ ' + messageScroll.length + ' ข้อความ' }}
          </el-tag>
        </div>
      </transition>
      <scroller
        ref="ChatBox__List"
        class="ChatBox__List"
        v-bind:isbuttom="scrollStatus == 'Down'"
        @on-scroll-top="loadMessageScroll"
        @on-scroll-bottom="$store.dispatch('chat/checkScrollTop', 'Down')"
      >
        <div v-loading="loadMore" class="ChatBox__loading"></div>
        <ChatMessage
          v-for="message in messages"
          v-bind:data="message"
          v-bind:key="message._id"
          v-bind:resId="profile.reservationId"
          v-bind:selectable="aiSuggestGlobalEnabled"
          v-bind:selected="selectedMessageIds.indexOf(message.chatHistoryId) > -1"
          v-bind:highlighted="highlightedMessageIds.indexOf(message.chatHistoryId) > -1"
          v-on:fnReSendMessage="reSendMessage"
          v-on:fnRemoveMessage="removeFailedMessage"
          v-on:toggleSelect="handleToggleSelectMessage"
          ref="dropbox"
        />
      </scroller>
      <div
        class="ChatBox__Input"
        v-show="!isShowHistory"
        :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
      >
        <transition name="component-fade" mode="out-in">
          <el-alert
            title="สคริปข้อความ : ข้อความเกิน 2000 ตัวอักษรไม่สามารถส่งข้อความได้"
            type="error"
            v-show="isCheckMsg"
          ></el-alert>
        </transition>
        <transition name="component-fade" mode="out-in">
          <sticker
            v-show="isShowSticker"
            @send-sticker-line="sendStickerToLine"
          ></sticker>
        </transition>
        <transition name="component-fade" mode="out-in">
          <image-often
            v-show="isShowOftenImages"
            @send-imageOften-line="sendImageOftenToLine"
          ></image-often>
        </transition>
        <vue-dropzone
          :options="dropzoneOptions"
          v-show="isShowDropzone && !isShowMessageSuggest && !isShowSticker"
          @vdropzone-sending="vsending"
          @vdropzone-success="vsuccess"
          @vdropzone-removed-file="vremoved"
          :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
          id="myDropzone"
          ref="myVueDropzone"
        ></vue-dropzone>
        <transition name="component-fade" mode="out-in">
          <el-button
            type="primary"
            ref="btnScrollDown"
            v-if="isShowBtnDownScroll"
            @click="setScrollDown"
            class="btn-down"
            icon="el-icon-caret-bottom"
            circle
          ></el-button>
        </transition>
        <!-- AI Suggestions Section -->
        <transition
          name="component-fade"
          mode="out-in"
          v-if="
            !$store.state.chat.isMobileMode &&
              aiSuggestGlobalEnabled &&
              aiSuggestions.length > 0
          "
        >
          <div
            class="ai-suggestions-container"
            v-show="
              !isShowDropzone &&
                !isShowProductSearch &&
                !isShowSticker &&
                !isShowOftenImages &&
                !$store.state.chat.disableSendMessage &&
                !isShowRefBooking
            "
          >
            <transition-group name="suggestion-slide" tag="div">
              <ai-suggestion
                v-for="suggestion in aiSuggestions"
                :key="suggestion.suggestionId"
                :data="suggestion"
                @useSuggestion="handleUseSuggestion"
                @sendSuggestion="handleSendSuggestion"
                @appendSuggestion="handleAppendSuggestion"
                @feedback="handleSuggestionFeedback"
                @close="handleCloseSuggestion"
                @hover="handleSuggestionHover"
                @jumpToMessage="handleJumpToMessage"
              ></ai-suggestion>
            </transition-group>
          </div>
        </transition>

        <transition
          name="component-fade"
          mode="out-in"
          v-if="!$store.state.chat.isMobileMode"
        >
          <el-form
            id="formSuggestMsg"
            class="form-tag"
            v-show="
              !isShowDropzone &&
                !isShowProductSearch &&
                !isShowSticker &&
                !isShowOftenImages &&
                !$store.state.chat.disableSendMessage
            "
          >
            <massage-suggest
              v-show="!isShowRefBooking"
              :templates="quickReplyProcessed"
              :expanded-code="quickReplyExpandedCode"
              @select="sendMessageSuggest"
              @toggle="handleQuickReplyToggle"
            ></massage-suggest>
            <div
              v-show="activeChatCustomer.refCode.length > 0"
              v-loading="refLoading"
            >
              <list-ref
                v-for="ref in activeChatCustomer.refCode"
                v-show="isShowRefBooking"
                v-bind:data="ref"
                v-bind:key="ref"
                v-on:fnSendRef="fnOpenAdatForBooking"
              ></list-ref>
              <div
                class="text-center"
                style="padding-bottom: 10px; padding-top:10px;"
                v-show="isShowRefBooking"
                @click="fnCreateAdatnotProductCode"
              >
                <el-button type="success" size="medium" plain
                  >สร้างความต้องการลูกค้า</el-button
                >
              </div>
            </div>
            <div
              v-show="activeChatCustomer.refCode.length == 0"
              class="text-center"
              v-loading="refLoading"
            >
              <span class="msg-pimary" v-show="isShowRefBooking"
                >ไม่มีข้อมูลโปรดักที่เสนอลูกค้า</span
              >
              <div
                class="text-center"
                style="padding-bottom: 10px; padding-top:10px;"
                v-show="isShowRefBooking"
                @click="fnCreateAdatnotProductCode"
              >
                <el-button type="success" size="medium" plain
                  >สร้างความต้องการลูกค้า</el-button
                >
              </div>
            </div>
          </el-form>
        </transition>
        <transition
          name="component-fade"
          mode="out-in"
          v-if="$store.state.chat.isMobileMode"
        >
          <el-form
            id="formRefCode"
            class="form-tag"
            :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
            v-show="isShowRefBooking"
          >
            <div
              v-show="activeChatCustomer.refCode.length > 0"
              v-loading="refLoading"
            >
              <list-ref
                v-for="ref in activeChatCustomer.refCode"
                v-show="isShowRefBooking"
                v-bind:data="ref"
                v-bind:key="ref"
                v-on:fnSendRef="fnOpenAdatForBooking"
              ></list-ref>
            </div>
            <div
              v-show="activeChatCustomer.refCode.length == 0"
              class="text-center"
              v-loading="refLoading"
            >
              <span class="msg-pimary" v-show="isShowRefBooking"
                >ไม่มีข้อมูลโปรดักที่เสนอลูกค้า</span
              >
            </div>
          </el-form>
        </transition>
        <transition name="component-fade" mode="out-in">
          <el-form
            id="formSearchProductCode"
            class="form-tag"
            :class="{ 'on-mobile': $store.state.chat.isMobileMode }"
            v-show="!isShowDropzone && isShowProductSearch"
          >
            <product-search
              v-loading="productLoading"
              :data="mouthProduct"
              ref="listProductSearch"
            ></product-search>
          </el-form>
        </transition>
        <ul class="nav nav-pills">
          <!-- Ask AI button - always visible when global enabled -->
          <li
            v-if="aiSuggestGlobalEnabled"
            class="ai-select-action-item"
          >
            <el-button
              type="primary"
              size="mini"
              :loading="aiSuggestLoading"
              :disabled="!aiSuggestEnabled"
              @click="handleManualSuggest"
            >
              <i class="fas fa-magic" style="font-size: 14px; margin-right: 6px;"></i>ถาม AI
            </el-button>
          </li>
          <li
            @click="sentToCustomer"
            ref="clicksent"
            v-show="!$store.state.chat.disableSendMessage"
          >
            <a>
              <i class="fa fa-paper-plane fa-2x"></i>
            </a>
          </li>
          <li ref="upload_file" v-show="!$store.state.chat.disableSendMessage">
            <a
              ref="link_uploadfile"
              class="file-upload"
              @click="selectFileUpload"
            >
              <i class="fas fa-paperclip fa-2x"></i>
            </a>
          </li>
          <li ref="sticker" v-show="!$store.state.chat.disableSendMessage">
            <a ref="link_sticker" @click="fnOpenSticker">
              <i class="far fa-smile fa-2x"></i>
            </a>
          </li>
          <li ref="often_images" v-show="!$store.state.chat.disableSendMessage">
            <a ref="often_image" @click="fnOpenOftenImages">
              <i class="fas fa-bookmark fa-2x"></i>
            </a>
          </li>
          <li v-show="!$store.state.chat.disableSendMessage">
            <div class="search-productcode">
              <el-input
                v-model="productCode"
                placeholder="ใส่รหัสตัวเลข 6 หลัก"
                maxlength="6"
                @keyup.enter.native="searchProduct"
              >
                <template slot="prepend">MUSH</template>
              </el-input>
              <el-button
                size="mini"
                @click="searchProduct"
                icon="el-icon-search"
                type="primary"
              ></el-button>
            </div>
          </li>
          <li>
            <div @click="fnOpenRefBooking">
              <span
                class="text-new"
                type="primary"
                v-show="
                  activeChatCustomer.BookingId == 0 &&
                    !$store.state.chat.isMobileMode
                "
                plain
              >
                <i class="far fa-check-square"></i> Booking ที่ลูกค้าสนใจ
              </span>
            </div>
            <div @click="fnOpenBooking">
              <span
                class="text-new msg-success"
                type="primary"
                v-show="activeChatCustomer.BookingId != 0"
                plain
              >
                <i class="fas fa-external-link-alt"></i> Booking ที่จองล่าสุด
              </span>
            </div>
          </li>
        </ul>
        <form ref="fromMsg" @submit="sendMessage" action="/" method="post">
          <canvas id="mycanvas" v-show="!isShowInput"></canvas>
          <div
            type="text"
            class="input-mssage hidden"
            v-text="urlCopyImage"
          ></div>
          <button
            type="button"
            v-show="!isShowInput"
            class="btn btn-default btn-sm"
          >
            Remove
          </button>
          <div class="replying-box" v-if="$store.state.chat.messageReplying">
            <div>
              <strong>ตอบกลับข้อความ</strong>&emsp;<el-button
                size="mini"
                type="warning"
                round
                @click="$store.commit('chat/messageReplying', null)"
                >ยกเลิก</el-button
              >
            </div>
            <div class="message-reply-preview">
              <div>
                <strong
                  >{{ this.$store.state.chat.messageReplying.custName }}:
                </strong>
              </div>
              <div v-html="replyHtml()"></div>
            </div>
          </div>
          <textarea
            id="chat-input"
            type="text"
            class="input-mssage"
            @keypress="sendMessage"
            ref="inputMsg"
            rows="5"
            cols="4"
            v-show="isShowInput"
            v-model="newMessages"
            :disabled="$store.state.chat.disableSendMessage"
            :placeholder="
              $store.state.chat.disableSendMessage
                ? $store.state.chat.disableSendMessageReason
                : 'Enter your message here'
            "
          />
          <div
            v-if="$store.state.chat.disableSendMessage"
            style="font-weight: bold; font-size: 18px; margin: 8px"
          >
            <a
              href="https://business.facebook.com/latest/inbox"
              target="_blank"
            >
              Go to Facebook Inbox
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.css';
import ChatMessage from './ChatMessage.vue';
import MassageSuggest from './MassageSuggest.vue';
import AiSuggestion from './AiSuggestion.vue';
import ListRef from './listRef.vue';
import ProductSearch from './listProductSearch.vue';
import Scroller from './ScrollbarMobile.vue';
import Sticker from './Sticker.vue';
import ImageOften from './ImageOften.vue';
import { convertChatHtml } from '../functions/format-string';

import { mapGetters } from 'vuex';
import {
  Form,
  Tag,
  Button,
  Input,
  Popover,
  Select,
  Option,
  Tooltip,
  Switch,
} from 'element-ui';
import { setTimeout } from 'timers';

export default {
  data() {
    return {
      newMessages: '',
      productCode: null,
      isShowDropzone: false,
      isShowSticker: false,
      isShowHistory: false,
      isShowOftenImages: false,
      isShowRefBooking: false,
      isShowInput: true,
      isShowMessageSuggest: false,
      aiSuggestToggle: false,
      selectedMessageIds: [],
      usedSuggestionId: null,
      highlightedMessageIds: [],
      urlImgeCopy: '',
      urlCopyImage: '',
      type: '',
      dropzoneOptions: {
        url: 'https://frontui.softsq.com/api/uploader',
        thumbnailWidth: 150,
        headers: {
          'Cache-Control': '',
          'X-Requested-With': '',
        },
        method: 'POST',
        paramName: 'SendFile01',
        addRemoveLinks: true,
        autoProcessQueue: true,
        accept(file, done) {
          done();
        },
      },
      isShowProductSearch: false,
      checklist: [],
      isShowBtnDownScroll: false,
      images: [],
      ps: null,
      isCheckMsg: false,
    };
  },
  components: {
    ChatMessage,
    vueDropzone: vue2Dropzone,
    MassageSuggest,
    AiSuggestion,
    ListRef,
    ProductSearch,
    Scroller,
    Sticker,
    ImageOften,
    [Form.name]: Form,
    [Tag.name]: Tag,
    [Button.name]: Button,
    [Input.name]: Input,
    [Popover.name]: Popover,
    [Select.name]: Select,
    [Option.name]: Option,
    [Tooltip.name]: Tooltip,
    [Switch.name]: Switch,
  },
  computed: {
    ...mapGetters('chat', [
      'activeChatCustomer',
      'activeChatCustomerName',
      'messages',
      'messagesLoading',
      'lastMessage',
      'quickReplyProcessed',
      'quickReplyExpandedCode',
      'firstMessage',
      'scrollStatus',
      'messageScroll',
      'productDetail',
      'mouthProduct',
      'periodsProduct',
      'productLoading',
      'listRefBooking',
      'refLoading',
      'loadMore',
      'newMessage',
      'numPeriods',
      'aiSuggestions',
      'aiSuggestEnabled',
      'aiSuggestLoading',
      'aiSuggestGlobalEnabled',
      'latestAiSuggestion',
    ]),
    ...mapGetters('profile', ['profile']),
  },
  watch: {
    aiSuggestEnabled: {
      immediate: true,
      handler(val) {
        this.aiSuggestToggle = val;
      },
    },
    urlImgeCopy: function(val) {
      if (val) {
        this.isShowInput = true;
        this.isShowDropzone = true;
        if (val.dataURL) {
          var formdata = new FormData();
          var blobObject = new Blob([val.dataURL], {
            type: 'image/jpeg',
          });
          formdata.append('SendFile01', blobObject);
          formdata.append('reservation_id', this.profile.reservationId);
          this.$http
            .post('https://frontui.softsq.com/api/uploader', formdata)
            .then(function(response) {
              let data = response.data.requesterInformation.receivedParams;
              var file = {
                size: data.SendFile01.size,
                name: response.data.remote_file_path,
                type: 'image/jpeg',
              };
              var url = response.data.remote_file_path;
              this.urlCopyImage = url;
              this.type = 'image';
              this.$refs.myVueDropzone.manuallyAddFile(file, url, {
                addToFiles: true,
                dontSubstractMaxFiles: false,
              });
            });
        }
      }
    },
    activeChatCustomer: {
      immediate: true,
      async handler(val, oldVal) {
        // Save draft for previous customer before switching
        if (oldVal && oldVal.custId) {
          this.$store.dispatch('chat/saveMessageDraft', {
            custId: oldVal.custId,
            text: this.newMessages,
            suggestionId: this.usedSuggestionId,
          });
        }

        if (!val || !val.custId) return;
        try {
          await this.loadCheckBooking(val.custId);
        } catch (ex) {
          console.log('cannot load booking lead');
        }
        this.isShowBtnDownScroll = false;
        this.$store.dispatch('chat/checkScrollTop', 'Down');
        this.$store.dispatch('chat/setMessageNew', []);
        this.productCode = null;
        this.isShowRefBooking = false;
        this.isShowProductSearch = false;
        this.$store.dispatch('chat/clearProductSearch');
        this.$store.dispatch('chat/clearPeriodProduct');
        await this.$store.dispatch('chat/loadMessages', {
          custId: val.custId,
          custName: val.custName,
          time: new Date().getTime(),
          type: 'none',
        });
        // Clear selected and highlighted messages on customer change
        this.selectedMessageIds = [];
        this.highlightedMessageIds = [];
        // Load AI suggestion status for this customer
        this.$store.commit('chat/CLEAR_AI_SUGGESTIONS');
        await this.$store.dispatch('chat/loadAiSuggestionStatus', val.custId);
        // Load all unresponded suggestions for this customer
        if (this.aiSuggestGlobalEnabled && this.aiSuggestEnabled) {
          await this.$store.dispatch('chat/loadAiSuggestionsRest', val.custId);
        }
        const vm = this;
        setTimeout(function() {
          vm.scrollToEnd();
        }, 200);
        this.$nextTick(() => {
          // this.scrollToEnd();
        });

        // Restore draft and used suggestion for new customer
        const draft = await this.$store.dispatch('chat/getMessageDraft', val.custId);
        this.newMessages = draft.text || '';
        this.usedSuggestionId = draft.suggestionId || null;
      },
    },
    profile: function(val) {
      return val;
    },
    scrollStatus: {
      immediate: true,
      handler(val) {
        if (val == 'Down') {
          this.$store.dispatch('chat/setMessageNew', []);
          this.isShowBtnDownScroll = false;
        } else {
          this.isShowBtnDownScroll = true;
        }
      },
    },
    productDetail: {
      immediate: true,
      handler(val) {
        if (val && this.productCode) {
          let messageProduct = '';
          let messageHeader =
            val.product_name +
            '\n\n' +
            val.stay_day +
            'วัน - ' +
            val.stay_night +
            'คืน' +
            ' สายการบิน ' +
            val.airline_name +
            '\n\n';

          if (val.promotion_discount && val.promotion_discount.length > 0) {
            messageHeader += `${val.promotion_discount
              .map(i => `🔖 ${i}`)
              .join('\n')}\n\n`;
          }
          /*   this.fnCheckUrlPdf(
              val.url_pdf,
              val.product_code.replace('MUSH', ''), */
          /*   ); */
          messageProduct = messageHeader;
          if (
            val.title_package != null &&
            val.title_package != '' &&
            val.title_package != undefined
          ) {
            messageProduct += val.title_package + '\n\n';
          }

          messageProduct += 'คลิกลิงก์ดูรายละเอียดโปรแกรม?\n';
          messageProduct += this.fnCheckUrlPdf(
            val.url_pdf,
            val.product_code.replace('MUSH', ''),
          );
          messageProduct +=
            '*หากเปิดลิงก์ไม่ได้ สามารถ copy ลิงก์ไปเปิดใน เบราเซอร์ Chrome หรือ Safari\n';

          messageProduct += '\n';

          // check promotion
          // สัญลักษณ์🔖 > เข้าร่วมโปรโมชัน
          // สัญลักษณ์▶️ > ไม่เข้าร่วมโปรโมชัน
          if (val.promotion_discount && val.promotion_discount.length > 0) {
            messageProduct +=
              'สัญลักษณ์🔖 > เข้าร่วมโปรโมชัน\nสัญลักษณ์▶️ > ไม่เข้าร่วมโปรโมชัน\n\n';
          }

          this.newMessages = messageProduct;
          this.isShowProductSearch = true;
        }
      },
    },
    periodsProduct: {
      immediate: true,
      handler(val) {
        if (val && this.productCode) {
          var str1 = this.newMessages;
          var res = str1.concat(val);
          if (res.length > 2000) {
            this.isCheckMsg = true;
          } else {
            this.isCheckMsg = false;
          }
          this.newMessages = res;
        }
      },
    },
    newMessages: {
      immediate: true,
      handler(val) {
        if (val == '') {
          this.productCode = null;
          this.isShowProductSearch = false;
          this.usedSuggestionId = null;
          this.$store.dispatch('chat/clearProductSearch');
        }
      },
    },
    productCode: {
      immediate: false,
      handler(val) {
        if (val) {
          if (val.length < 6) {
            this.isShowProductSearch = false;
          }
        } else {
          this.newMessages = '';
          this.isShowProductSearch = false;
          this.$store.commit('chat/SET_NUM_PERIODS', null);
        }
      },
    },
    newMessage: {
      immediate: true,
      handler(val) {
        if (val) {
          if (
            val.custId == this.activeChatCustomer.custId &&
            this.scrollStatus != 'Top'
          ) {
            setTimeout(() => {
              var height = 0;
              $('.Message').each(function() {
                height += parseInt($(this).height()) + 200;
              });
              height += '';
              this.$el.querySelector('.ChatBox__List').scrollTop = parseInt(
                height,
              );
            }, 500);
          }
        }
      },
    },
  },
  methods: {
    sendMessage(event) {
      this.isCheckMsg = false;
      if (event.keyCode == 13 && event.shiftKey) {
        return false;
      }
      if (event.keyCode == 13) {
        event.preventDefault();
        if (this.newMessages != '' || this.urlCopyImage != '') {
          if (this.type == '') {
            this.type = checkTypeMssage(this.newMessages);
          }
          if (this.newMessages.length > 2000) {
            this.type = 'string';
            this.isCheckMsg = true;
          } else {
            this.isCheckMsg = false;
            let msg =
              this.urlCopyImage != '' ? this.urlCopyImage : this.newMessages;
            const sentSuggestionId = this.usedSuggestionId;
            this.usedSuggestionId = null; // Clear immediately so rapid follow-up messages don't reuse it
            this.$store.dispatch('chat/sendMessage', {
              nickname: this.profile.nickName,
              message: msg,
              custName: 'Me',
              type: this.type,
              suggestionId: sentSuggestionId,
            });
            // Remove the used suggestion row after sending
            if (sentSuggestionId) {
              this.$store.commit('chat/REMOVE_AI_SUGGESTION', sentSuggestionId);
            } else {
              this.dismissAllSuggestions();
            }
            setTimeout(() => {
              this.urlCopyImage = '';
              this.type = '';
              this.newMessages = '';
              this.isShowDropzone = false;
              this.$refs.myVueDropzone.removeAllFiles();
              this.$refs.listProductSearch.clear();
              this.isShowBtnDownScroll = false;
              this.isShowRefBooking = false;
              this.isShowSticker = false;
              this.isShowOftenImages = false;
              this.scrollToEnd();
              // Clear draft after sending
              if (this.activeChatCustomer && this.activeChatCustomer.custId) {
                this.$store.dispatch('chat/saveMessageDraft', {
                  custId: this.activeChatCustomer.custId,
                  text: '',
                });
              }
            }, 100);
          }
        }
      }
    },
    sentToCustomer() {
      this.isCheckMsg = false;
      if (this.newMessages != '' || this.urlCopyImage != '') {
        if (this.type == '') {
          this.type = checkTypeMssage(this.newMessages);
        }
        // push message by font
        if (this.newMessages != '' || this.urlCopyImage != '') {
          if (this.type == '') {
            this.type = checkTypeMssage(this.newMessages);
          }
          if (this.newMessages.length > 2000) {
            this.type = 'string';
            this.isCheckMsg = true;
          } else {
            this.isCheckMsg = false;
            let msg =
              this.urlCopyImage != '' ? this.urlCopyImage : this.newMessages;
            const sentSuggestionId = this.usedSuggestionId;
            this.usedSuggestionId = null; // Clear immediately so rapid follow-up messages don't reuse it
            this.$store.dispatch('chat/sendMessage', {
              nickname: this.profile.nickName,
              message: msg,
              custName: 'Me',
              type: this.type,
              suggestionId: sentSuggestionId,
            });
            // Remove the used suggestion row after sending
            if (sentSuggestionId) {
              this.$store.commit('chat/REMOVE_AI_SUGGESTION', sentSuggestionId);
            } else {
              this.dismissAllSuggestions();
            }
            setTimeout(() => {
              this.urlCopyImage = '';
              this.type = '';
              this.newMessages = '';
              this.isShowDropzone = false;
              this.$refs.myVueDropzone.removeAllFiles();
              this.$refs.listProductSearch.clear();
              this.isShowBtnDownScroll = false;
              this.isShowRefBooking = false;
              this.isShowSticker = false;
              this.isShowOftenImages = false;
              this.scrollToEnd();
              // Clear draft after sending
              if (this.activeChatCustomer && this.activeChatCustomer.custId) {
                this.$store.dispatch('chat/saveMessageDraft', {
                  custId: this.activeChatCustomer.custId,
                  text: '',
                });
              }
            }, 500);
          }
        }
      }
    },
    selectFileUpload: function() {
      if (this.isShowDropzone == true) {
        this.$refs.myVueDropzone.removeAllFiles();
      }
      this.isShowDropzone == false
        ? (this.isShowDropzone = true)
        : (this.isShowDropzone = false);
      this.newMessages = '';
      this.isShowSticker = false;
      this.isShowMessageSuggest = false;
      $('body, html').animate(
        {
          scrollTop: 1500,
        },
        'slow',
      );
    },
    fnOpenSticker: function() {
      this.isShowSticker == true
        ? (this.isShowSticker = false)
        : (this.isShowSticker = true);
      this.isShowDropzone = false;
      this.isShowMessageSuggest = false;
      this.isShowOftenImages = false;
    },
    fnOpenOftenImages: function() {
      this.isShowOftenImages == true
        ? (this.isShowOftenImages = false)
        : (this.isShowOftenImages = true);
      this.isShowDropzone = false;
      this.isShowMessageSuggest = false;
      this.isShowSticker = false;
    },
    fnShowHistory() {
      this.isShowHistory == true
        ? (this.isShowHistory = false)
        : (this.isShowHistory = true);
      $('body, html').animate(
        {
          scrollTop: 1500,
        },
        'slow',
      );
    },
    vsending(file, xhr, formData) {
      formData.set('reservation_id', this.profile.reservationId);
      this.sending = true;
    },
    vsuccess(file, response) {
      this.type = checkTypeFile(
        response.requesterInformation.receivedParams.SendFile01.type,
      );
      this.urlCopyImage = response.remote_file_path;
      setTimeout(() => {
        if (this.urlCopyImage == '' && this.type == '') {
          return false;
        }
        this.$store.dispatch('chat/sendMessage', {
          nickname: this.profile.nickName,
          message: this.urlCopyImage,
          custName: 'Me',
          type: this.type,
        });
        this.success = true;
        setTimeout(() => {
          this.urlCopyImage = '';
          this.type = '';
          this.newMessages = '';
          this.isShowDropzone = false;
          this.$refs.myVueDropzone.removeAllFiles();
          this.$refs.listProductSearch.clear();
          this.isShowBtnDownScroll = false;
          this.isShowSticker = false;
          this.isShowOftenImages = false;
          this.scrollToEnd();
        }, 500);
      }, 15000);
    },
    vremoved() {
      this.urlCopyImage = '';
      this.type = '';
      this.newMessages = '';
      this.$refs.myVueDropzone.removeAllFiles();
    },
    sendMessageSuggest(text) {
      // this.$store.dispatch('chat/sendMessage', {
      //   nickname: this.profile.nickName,
      //   message: text,
      //   custName: 'Me',
      //   type: 'string',
      // });
      //this.isShowBtnDownScroll = false;
      //this.scrollToEnd();
      this.newMessages = text;
    },
    sendStickerToLine(url) {
      this.$store.dispatch('chat/sendMessage', {
        nickname: this.profile.nickName,
        message: url,
        custName: 'Me',
        type: 'image',
      });
      setTimeout(() => {
        this.urlCopyImage = '';
        this.type = '';
        this.newMessages = '';
        this.isShowDropzone = false;
        this.isShowBtnDownScroll = false;
        this.isShowSticker = false;
        this.isShowRefBooking = false;
        this.scrollToEnd();
      }, 100);
    },
    sendImageOftenToLine(url, type) {
      this.$store.dispatch('chat/sendMessage', {
        nickname: this.profile.nickName,
        message: url,
        custName: 'Me',
        type: type,
      });
      setTimeout(() => {
        this.urlCopyImage = '';
        this.type = '';
        this.newMessages = '';
        this.isShowDropzone = false;
        this.isShowBtnDownScroll = false;
        this.isShowSticker = false;
        this.isShowOftenImages = false;
        this.isShowRefBooking = false;
        this.scrollToEnd();
      }, 100);
    },
    handleQuickReplyToggle(code) {
      this.$store.dispatch('chat/toggleQuickReplyExpanded', code);
    },
    // AI Suggestion methods
    handleAiSuggestToggle(enabled) {
      if (!this.activeChatCustomer) return;
      this.$store.dispatch('chat/toggleAiSuggest', {
        customerId: this.activeChatCustomer.custId,
        enabled,
      });
      if (enabled) {
        // Load suggestions when enabled
        this.$store.dispatch(
          'chat/loadAiSuggestionsRest',
          this.activeChatCustomer.custId,
        );
      }
    },
    handleUseSuggestion({ suggestionId, text }) {
      // Populate the message input (replace)
      this.newMessages = text;
      // Track the suggestion ID to send with the message
      this.usedSuggestionId = suggestionId;
      // Keep suggestion box open - don't remove
      // Clear highlighted messages
      this.highlightedMessageIds = [];
    },
    handleAppendSuggestion({ suggestionId, text }) {
      // Append to existing message input with spacing
      if (this.newMessages.trim()) {
        this.newMessages = this.newMessages.trim() + '\n\n' + text + '\n';
      } else {
        this.newMessages = text + '\n';
      }
      // Track the suggestion ID
      this.usedSuggestionId = suggestionId;
      // Keep suggestion box open - don't remove
      // Clear highlighted messages
      this.highlightedMessageIds = [];
      // Show toast notification at bottom
      this.$message({
        message: 'เพิ่มข้อความแล้ว',
        type: 'success',
        duration: 1500,
        customClass: 'message-bottom',
      });
    },
    handleSendSuggestion({ suggestionId, text }) {
      // 1. Send message directly (must be first to ensure immediate UI update)
      this.$store.dispatch('chat/sendMessage', {
        nickname: this.profile.nickName,
        message: text,
        custName: 'Me',
        type: checkTypeMssage(text),
        suggestionId: suggestionId,
      });

      // 2. Remove suggestion
      this.$store.commit('chat/REMOVE_AI_SUGGESTION', suggestionId);

      // 3. Submit positive feedback in background (non-blocking)
      this.$store.dispatch('chat/submitSuggestionFeedback', {
        suggestionId,
        isCorrect: true,
      });

      // 4. Clear highlighted messages
      this.highlightedMessageIds = [];

      // 5. Scroll to end
      this.scrollToEnd();
    },
    handleSuggestionFeedback({ suggestionId, isCorrect }) {
      this.$store.dispatch('chat/submitSuggestionFeedback', {
        suggestionId,
        isCorrect,
        feedbackNote: isCorrect ? '' : 'Marked as incorrect by agent',
      });
      // Thumbs down: also remove from UI (marked as responded)
      if (!isCorrect) {
        this.$store.commit('chat/REMOVE_AI_SUGGESTION', suggestionId);
      }
    },
    handleCloseSuggestion(suggestionId) {
      // Remove the suggestion from the list
      this.$store.commit('chat/REMOVE_AI_SUGGESTION', suggestionId);
      // Mark as dismissed on backend
      this.$store.dispatch('chat/dismissSuggestion', suggestionId);
      // Clear tracking if closing the suggestion that was used
      if (this.usedSuggestionId === suggestionId) {
        this.usedSuggestionId = null;
      }
    },
    dismissAllSuggestions() {
      if (this.aiSuggestions && this.aiSuggestions.length > 0) {
        this.aiSuggestions.forEach(s => {
          this.$store.dispatch('chat/dismissSuggestion', s.suggestionId);
        });
        this.$store.commit('chat/CLEAR_AI_SUGGESTIONS');
      }
    },
    handleSuggestionHover(ids) {
      this.highlightedMessageIds = ids;
    },
    handleJumpToMessage(messageId) {
      if (messageId) {
        this.$store.dispatch('chat/toQuotedMessage', messageId);
      }
    },
    // Manual suggestion methods
    handleToggleSelectMessage(message) {
      const id = message.chatHistoryId;
      if (!id) return;
      const idx = this.selectedMessageIds.indexOf(id);
      if (idx > -1) {
        this.selectedMessageIds.splice(idx, 1);
      } else {
        this.selectedMessageIds.push(id);
      }
    },
    clearSelection() {
      this.selectedMessageIds = [];
    },
    async handleManualSuggest() {
      if (!this.activeChatCustomer) return;

      const chatHistoryIds = this.selectedMessageIds.filter(
        id => typeof id === 'string' && /^[a-f0-9]{24}$/.test(id)
      );

      const result = await this.$store.dispatch('chat/manualSuggest', {
        chatHistoryIds,
        customerId: this.activeChatCustomer.custId,
      });
      if (result) {
        // Clear selection after successful suggestion
        this.selectedMessageIds = [];
      }
    },
    loadMessageScroll() {
      if (this.firstMessage) {
        this.$store.dispatch('chat/checkScrollTop', 'Top');
        this.$store.dispatch('chat/setLoadMore', true);
        this.$store.dispatch('chat/loadMoreMessage', {
          custId: this.firstMessage.custId,
          custName: this.firstMessage.custName,
          time: this.firstMessage.time,
          type: 'scroll',
        });
      } else {
        this.$store.dispatch('chat/checkScrollTop', 'Top');
      }
    },
    setScrollDown() {
      this.isShowBtnDownScroll = false;
      this.$store.dispatch('chat/checkScrollTop', 'Down');
      this.$store.dispatch('chat/setMessageNew', []);
      this.scrollToEnd();
    },
    searchProduct() {
      this.$refs.listProductSearch.clear();
      this.$store.commit('chat/SET_NUM_PERIODS', null);
      this.$store.dispatch('chat/searchProduct', this.productCode);
      this.isShowProductSearch = true;
    },
    fnOpenAdatForBooking(ev) {
      this.activeChatCustomer.productCode = ev.replace('MUSH', '');
      this.$store.dispatch('chat/openAdatForBooking', this.activeChatCustomer);
    },
    fnCreateAdatnotProductCode() {
      this.$store.dispatch('chat/openAdatForBooking', this.activeChatCustomer);
    },
    fnOpenRefBooking(item) {
      if (!this.refLoading) {
        this.$refs.listProductSearch.clear();
        this.isShowRefBooking = !this.isShowRefBooking;
        this.isShowProductSearch = false;
      } else {
        return false;
      }
    },
    fnOpenBooking(ev) {
      console.log('fnOpenBooking : ', this.refLoading);
      if (!this.refLoading) {
        this.$store.dispatch(
          'chat/openBooking',
          this.activeChatCustomer.BookingId,
        );
      } else {
        return false;
      }
    },
    fnreturnListChat() {
      this.$store.dispatch('chat/setActiveChatCustumer', null);
      this.$router.push({ path: '/chat' });
    },
    async reSendMessage(data) {
      const { request, error } = await this.$store.dispatch(
        'chat/resendMessage',
        data,
      );
      if (request === 'success') {
        this.$message({
          message: 'ส่งข้อความสำเร็จ',
          type: 'success',
          duration: 2000,
        });
      } else {
        this.$message({
          message: error || 'การส่งข้อความล้มเหลว กรุณาลองใหม่อีกครั้ง',
          type: 'error',
          duration: 3000,
        });
      }
    },
    removeFailedMessage(data) {
      this.$store.dispatch('chat/removeFailedMessage', data);
      this.$message({ message: 'ลบข้อความแล้ว', type: 'info', duration: 2000 });
    },
    async loadCheckBooking(custId) {
      let responseRequest;
      const bookingLeadReq = this.$store.dispatch(
        'chat/searchBookingLead',
        custId,
      );
      this.$store.commit('chat/SET_LOADING_REF', true);
      if (this._cancelRefBooking) this._cancelRefBooking();
      await this.$store
        .dispatch('chat/loadCheckBooking', custId)
        .then(({ request, cancel }) => {
          this._cancelRefBooking = cancel;
          responseRequest = request;
        });

      // check if has booking lead. replace mainbookingId
      await bookingLeadReq; // state commited inside store
      this.$store.commit('chat/SET_LOADING_REF', false);
      return responseRequest;
    },
    fnCheckUrlPdf(url, code) {
      if (url && url != '' && url.length > 0) {
        const fontFile = url.slice(0, 2);
        if (fontFile != 'ht') {
          return 'https://cdn.mushroomtravel.com/f/' + code + '.pdf\n';
        } else {
          return url + '\n';
        }
      } else {
        return 'https://cdn.mushroomtravel.com/f/' + code + '.pdf \n';
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        var height = 0;
        $('.Message').each(function() {
          height += parseInt($(this).height()) + 200;
        });
        height += '';
        this.$el.querySelector('.ChatBox__List').scrollTop = parseInt(height);
      }, 200);
    },
    copyName(name) {
      const vm = this;
      navigator.clipboard
        .writeText(name.trim())
        .then(() => {
          vm.$message({
            message: 'Copied to clipboard successfully!',
            type: 'success',
            duration: 2000,
          });
        })
        .catch(() => {
          vm.$message.error('Failed to copy text');
        });
    },
    replyHtml() {
      if (!this.$store.state.chat.messageReplying) {
        return '';
      }
      const { type, msg } = this.$store.state.chat.messageReplying;
      return convertChatHtml(type, msg);
    },
  },
  mounted() {
    console.log('--- mounted Chatbox ---');
    window.addEventListener(
      'paste',
      e => {
        retrieveImageFromClipboardAsBlob(e, imageBlob => {
          if (imageBlob) {
            const item = this;
            var canvas = document.getElementById('mycanvas');
            var ctx = canvas.getContext('2d');
            var img = new Image();
            var URLObj = window.URL || window.webkitURL;
            img.src = URLObj.createObjectURL(imageBlob);
            img.name =
              img.src.replace('blob:' + window.location.origin + '/', '') +
              '.png';
            img.onload = function() {
              canvas.width = this.width;
              canvas.height = this.height;
              ctx.drawImage(img, 0, 0);
              var dataURL = canvas.toDataURL('image/jpeg', 0.5);
              item.urlImgeCopy = {
                dataURL: dataURL,
              };
            };
          }
        });
      },
      false,
    );
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  },
  updated() {
    if (this.scrollStatus == 'Top' || this.isShowBtnDownScroll == true) {
      return false;
    }
  },
  beforeDestroy() {
    if (this._cancelRefBooking) this._cancelRefBooking();
  },
  destroyed() {},
};

function checkTypeMssage(msg) {
  var regex = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/; // eslint-disable-line
  if (msg.indexOf('ui-path-img') > 0) {
    return 'image';
  } else if (regex.test(msg)) {
    return 'url';
  } else {
    return 'string';
  }
}

function checkTypeFile(type) {
  if (type == 'image/jpeg' || type == 'image/png') {
    return 'image';
  } else if (type.indexOf('document')) {
    return 'url';
  }
}

function retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
  if (pasteEvent.clipboardData == false) {
    if (typeof callback == 'function') {
      callback(undefined);
    }
  }

  var items = pasteEvent.clipboardData.items;

  if (items == undefined) {
    if (typeof callback == 'function') {
      callback(undefined);
    }
  }

  for (var i = 0; i < items.length; i++) {
    // Skip content if not image
    if (items[i].type.indexOf('image') == -1) continue;
    var imageFile = items[i].getAsFile();
    if (typeof callback == 'function') {
      callback(imageFile);
    }
  }
}
</script>

<style>
#ChatBox {
  width: 100%;
  height: 100%;
  margin-right: 0;
}
#ChatBox.on-mobile {
  padding-top: 85px;
}
#ChatBox .panel.panel-default {
  position: fixed;
  width: 100%;
  border-left: none;
  background: #00978b;
  color: #fff;
  margin-bottom: unset;
}
#ChatBox .panel.panel-default.on-mobile {
  top: 0;
}
#ChatBox .panel {
  border-radius: unset;
  border: unset;
}

.ChatBox__Input.on-mobile {
  position: fixed;
  bottom: 0px;
  width: 100%;
  display: block;
}

#Chat__ChatBox ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.ChatBox__Left {
  padding-right: 0;
}

.ChatBox__Right {
  height: 100vh;
  border-left: 1px solid #eee;
  background: #f7f7f7;
  box-shadow: -10px 0 40px #f1f1f1;
}
.icon-edit {
  font-size: 22px;
  padding-left: 10px;
  cursor: pointer;
}

.ChatBox__List {
  padding-top: 20px;
  background-image: url(/static/img/mushroom.c044920.png);
  background-position: center;
  background-repeat: no-repeat;
  background-size: 400px;
  background-blend-mode: screen;
  position: relative;
  display: block;
  /* height: 735px; */
  /*   overflow-y: scroll; */
}
.ChatBox__List::-webkit-scrollbar-track {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.ChatBox__List::-webkit-scrollbar {
  width: 15px;
  background-color: #f5f5f5;
  position: relative;
}

.ChatBox__List::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #00978b;
}
.ChatBox__Input input {
  width: 100%;
  background: white;
  /* padding: 10px; */
}

.ChatBox__Input input:focus {
  outline: none;
}

ul.ChatBox__OnlineUsers {
  list-style: none;
  margin: 0;
  padding: 0;
}

h3 {
  margin-top: 20px;
  text-transform: uppercase;
  margin-bottom: 5px;
  font-size: 16px;
  font-weight: bold;
  color: #999;
}

.ChatBox__Input {
  position: relative;
}
.ChatBox__Input ul.nav.nav-pills {
  width: 100%;
  background: #eee;
  padding-right: 20px;
}

.ChatBox__Input ul.nav.nav-pills li {
  float: right;
}

.ChatBox__Input ul.nav.nav-pills li a {
  color: #999;
  cursor: pointer;
  padding: 10px 12px;
}

.ChatBox__Input ul.nav.nav-pills li a.linkupload {
  margin-top: 8px;
  color: #00978b;
  cursor: pointer;
}

textarea[type='text'].input-mssage {
  border: none;
}
textarea[type='text'].input-mssage:disabled {
  background-color: #eeeeee;
  font-size: 32px;
}

#ChatBox .media-body a {
  color: #ffff;
  position: fixed;
  right: 30px;
  top: 30px;
}

#ChatBox .media-body {
  padding-top: 15px;
  padding-left: 5px;
}

.file-upload input[type='file'] {
  display: none;
}
.tag-newMessage {
  position: fixed;
  font-size: 20px;
  margin-left: 430px;
  cursor: pointer;
  display: block;
  z-index: 3;
}
.el-tag--success {
  background-color: #00978b;
  border-color: #00978b;
  color: #ffffff;
}
.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* AI Suggestion slide-in transition */
.suggestion-slide-enter-active {
  transition: all 0.4s ease-out;
}
.suggestion-slide-leave-active {
  transition: all 0.25s ease-in;
}
.suggestion-slide-enter {
  opacity: 0;
  transform: translateY(-15px);
}
.suggestion-slide-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
.suggestion-slide-move {
  transition: transform 0.3s ease;
}
.el-button.btn-down {
  position: absolute;
  margin-left: 935px;
  bottom: 336px;
  display: block;
  background-color: #00978b;
  font-size: 26px;
  padding: 17px;
  border-color: #00978b;
  border-radius: 100%;
}
.el-button.btn-down:hover {
  background-color: #00978bcc;
  border-color: #00978bcc;
}
i.el-icon-search {
  font-size: 28px;
}
.search-productcode {
  margin-top: 4px;
}
.slide-enter-active,
.slide-leave-active {
  transition: margin-bottom 0.8s ease-out;
}
.slide-enter,
.slide-leave-to {
  margin-bottom: -200px;
}
.slide-enter-to,
.slide-leave {
  margin-bottom: 0px;
}
.form-tag {
  margin: 10px 0 0 0;
  padding: 10px 10px 0px 10px;
  -webkit-box-shadow: 0px 0px 3px 0px rgba(201, 199, 201, 1);
  -moz-box-shadow: 0px 0px 3px 0px rgba(201, 199, 201, 1);
  box-shadow: 0px 0px 3px 0px rgba(201, 199, 201, 1);
  background: #fff;
}
.el-button--mini {
  display: inline-block;
  position: absolute;
  float: left;
  margin-left: 5px;
  padding: 5px 15px;
}
.el-input-group {
  float: left;
}
.search-productcode {
  margin-right: 75px;
}
.btn-new .el-button--success {
  margin-top: 3px;
  font-size: 20px;
}
.btn-new .el-button--primary {
  margin-top: 3px;
  font-size: 20px;
}
#formListRef {
  height: 110px;
}
span.text-new {
  font-size: 20px;
  color: #409eff;
  cursor: pointer;
  line-height: 52px;
  padding-right: 20px;
}
.text-center {
  text-align: center;
}
.text-center .msg-pimary {
  font-size: 22px;
  text-align: center;
  color: #409eff;
  display: inline-block;
  margin-bottom: 15px;
}
span.text-new.msg-success {
  font-size: 20px;
  color: #00978bd4;
  cursor: pointer;
  line-height: 52px;
  padding-right: 20px;
}
.btn-message {
  margin-right: 85px;
  margin-top: 5px;
}
.btn-message button {
  font-size: 18px;
}
.text-warining {
  font-size: 18px;
  padding: 5px 10px 5px 10px;
  border: 1px solid;
  background-color: rgb(234, 243, 253);
  border: 1px solid rgba(64, 158, 255, 0.2);
  color: #409eff;
  position: absolute;
  bottom: 309px;
  width: 69%;
  z-index: 1000;
}
.ChatBox__loading {
  margin-bottom: 10px;
  margin-top: 10px;
}
.ChatBox_writeSpace {
  padding: 45px;
}
#ChatBox .ChatBox__Input ul.nav.nav-pills {
  margin-top: unset;
}
.el-alert__title {
  font-size: 16px;
}
#formSuggestMsg .el-button--medium {
  font-size: 16px;
}
.el-form.form-tag.on-mobile {
  position: absolute;
  width: 100%;
  z-index: 3000;
  bottom: 100%;
}
.vue-dropzone.dropzone.on-mobile.dz-clickable {
  position: absolute;
  width: 100%;
  z-index: 3000;
  bottom: 100%;
}
.replying-box {
  font-size: 18px;
  background-color: #d5fffc;
  padding: 8px;
  border-bottom: 1px dashed #b5b5b5;
}
.replying-box div {
  margin: 4px 4px 8px;
}
.message-reply-preview {
  display: flex;
  align-items: start;
}
.message-reply-preview img {
  max-height: 100px;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 4px 15px;
  font-size: 16px;
}
/* AI Suggestions Styles */
.ai-suggestions-container {
  padding: 10px;
  padding-top: 24px;
  background: rgba(252, 237, 215, 0.85);
  border-radius: 8px;
  overflow-y: auto;
  max-height: 230px;
  position: absolute;
  bottom: 100%;
  left: 420px;
  right: 16px;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.ai-toggle-wrapper {
  vertical-align: middle;
}
.ai-toggle-wrapper .el-switch {
  transform: scale(0.8);
}
/* AI Select Button */
.ai-select-btn {
  cursor: pointer;
  color: #ddd;
  font-size: 14px;
  padding: 2px 6px;
  border-radius: 4px;
  transition: all 0.2s;
}
.ai-select-btn:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.2);
}
.ai-select-btn.active {
  color: #13ce66;
  background: rgba(19, 206, 102, 0.15);
}
/* AI Select Action Item in toolbar */
.ChatBox__Input ul.nav.nav-pills li.ai-select-action-item {
  float: left !important;
  display: flex !important;
  align-items: center;
  gap: 6px;
  padding: 24px 12px;
  background: none;
  white-space: nowrap;
  font-size: 36px;
}
.ai-select-action-item .el-button--primary {
  background-color: #1976d2;
  border-color: #1976d2;
  font-size: 22px;
  min-width: 120px;
}
.ai-select-action-item .el-button--primary.is-disabled {
  background-color: #a0c4e8;
  border-color: #a0c4e8;
  cursor: not-allowed;
}
.ai-select-count {
  font-size: 14px;
  color: #1565c0;
  font-weight: 500;
}
.ask-ai-icon-small {
  width: 14px;
  height: 14px;
  vertical-align: middle;
  margin-right: 2px;
  filter: brightness(0) invert(1);
}
</style>

<style>
/* Global style for Element UI Message bottom positioning */
.message-bottom {
  top: auto !important;
  bottom: 80px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ChatBox.vue